module.exports = __webpack_public_path__ + "static/onboarding-ccd84cddeaedc927460adb07312968c8.svg";